var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _circle2, _path8, _circle3, _path9, _circle4, _path10, _circle5, _path11, _circle6, _path12, _circle7, _path13, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkguideFeaturesAdaptable300X300(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203.65 263.59c-24.34 0-43.27-16.69-57.59-50.6l1.85-.78c7.94 18.81 17 31.87 27.66 39.93 12.33 9.3 26.49 11.73 43.3 7.4l.5 1.93a63 63 0 01-15.72 2.12zM135.67 84c-16-1-40.28-29.22-46.46-45.72l1.88-.7C97.67 55.16 121.91 81.11 135.8 82zM148.73 88.47l-2-.23c2.88-25.53 7.68-39.28 15.59-44.59 6.93-4.65 15.19-2.32 24.75.39 15.19 4.3 32.41 9.18 51.73-10.74l1.43 1.39C220.1 55.47 201.49 50.2 186.54 46c-9.09-2.58-16.93-4.8-23.09-.66-7.28 4.86-11.96 18.57-14.72 43.13z",
    fill: "#dee0ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.11 150.39l-2-.17c.08-1 2.26-23.71 19.13-33.29 11.54-6.55 27-5.22 45.95 3.95 11.16 5.4 20.17 6 26.76 1.92 12.21-7.65 12.37-29.32 12.37-29.54h2a57.74 57.74 0 01-1.64 12.41c-2.16 8.88-6.19 15.39-11.66 18.82-7.22 4.52-16.87 3.91-28.7-1.81-18.33-8.87-33.16-10.22-44.09-4-15.96 9.06-18.1 31.49-18.12 31.71z",
    fill: "#ffd9e2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M194.05 111.76c-1.31-18.21 2.67-35 11.51-48.62C212 53.25 221.17 45 230.12 41l.81 1.83c-13.35 5.92-37.82 27.92-34.88 68.78z",
    fill: "#dee0ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.59 218a19.74 19.74 0 01-11.35-3.12c-11.28-7.7-11.65-29.54-1.08-64.88 10.3-34.47 10.12-55.69-.53-63.07-19.18-13.27-66.63 22.44-67.09 22.81l-1.21-1.6c2-1.51 49.07-36.94 69.44-22.83 11.44 7.92 11.88 29.89 1.3 65.28-10.28 34.42-10.18 55.5.3 62.66 18.92 12.94 66.08-23.5 66.55-23.87l1.23 1.57c-1.67 1.3-35.02 27.05-57.56 27.05z",
    fill: "#4355b9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.45 261.09c-13.12-18.22-16.64-38.88-9.93-58.2 8.57-24.64 32.38-44.16 65.32-53.55l.55 1.93c-32.31 9.2-55.63 28.26-64 52.28-6.49 18.68-3.06 38.7 9.66 56.37z",
    fill: "#dee0ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.05 182.08a148.28 148.28 0 01-23.25-2l.31-2c52 8.25 67.07-12.83 67.21-13l1.66 1.13c-.53.79-11.32 15.87-45.93 15.87z",
    fill: "#ffd9e2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.94,
    cy: 111.69,
    r: 12,
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.94 124.69a13 13 0 1113-13 13 13 0 01-13 13zm0-24a11 11 0 1011 11 11 11 0 00-11-11z",
    fill: "#4355b9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.74,
    cy: 211.64,
    r: 12,
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M147.74 224.65a13 13 0 1113-13 13 13 0 01-13 13zm0-24a11 11 0 1011 11 11 11 0 00-11-11z",
    fill: "#4355b9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.74,
    cy: 88.36,
    r: 12,
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M147.74 101.36a13 13 0 1113-13 13 13 0 01-13 13zm0-24a11 11 0 1011 11 11 11 0 00-11-11z",
    fill: "#4355b9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.33,
    cy: 88.36,
    r: 12,
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M252.33 101.36a13 13 0 1113-13 13 13 0 01-13 13zm0-24a11 11 0 1011 11 11 11 0 00-11-11z",
    fill: "#ffd9e2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.15,
    cy: 256.83,
    r: 12,
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.15 269.83a13 13 0 1113-13 13 13 0 01-13 13zm0-24a11 11 0 1011 11 11 11 0 00-11-11z",
    fill: "#dee0ff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.15,
    cy: 181.06,
    r: 12,
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.15 194.06a13 13 0 1113-13 13 13 0 01-13 13zm0-24a11 11 0 1011 11 11 11 0 00-11-11z",
    fill: "#ffd9e2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.05,
    cy: 111.69,
    r: 12,
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M195.05 124.69a13 13 0 1113-13 13 13 0 01-13 13zm0-24a11 11 0 1011 11 11 11 0 00-11-11z",
    fill: "#ffd9e2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 239.52,
    cy: 34,
    r: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.52 47a13 13 0 1113-13 13 13 0 01-13 13zm0-24a11 11 0 1011 11 11 11 0 00-11-11z",
    fill: "#dee0ff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 137.5,
    y: 135.03,
    width: 24,
    height: 24,
    rx: 5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.5 160h-14a6 6 0 01-6-6v-14a6 6 0 016-6h14a6 6 0 016 6v14a6 6 0 01-6 6zm-14-24a4 4 0 00-4 4v14a4 4 0 004 4h14a4 4 0 004-4v-14a4 4 0 00-4-4z",
    fill: "#4355b9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 165.72,
    y: 25.93,
    width: 24,
    height: 24,
    rx: 5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.72 50.93h-14a6 6 0 01-6-6v-14a6 6 0 016-6h14a6 6 0 016 6v14a6 6 0 01-6 6zm-14-24a4 4 0 00-4 4v14a4 4 0 004 4h14a4 4 0 004-4v-14a4 4 0 00-4-4z",
    fill: "#dee0ff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.15,
    y: 163.64,
    width: 24,
    height: 24,
    rx: 5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.15 188.65h-14a6 6 0 01-6-6v-14a6 6 0 016-6h14a6 6 0 016 6v14a6 6 0 01-6 6zm-14-24a4 4 0 00-4 4v14a4 4 0 004 4h14a4 4 0 004-4v-14a4 4 0 00-4-4z",
    fill: "#dee0ff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 78.15,
    y: 25.93,
    width: 24,
    height: 24,
    rx: 5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.15 50.93h-14a6 6 0 01-6-6v-14a6 6 0 016-6h14a6 6 0 016 6v14a6 6 0 01-6 6zm-14-24a4 4 0 00-4 4v14a4 4 0 004 4h14a4 4 0 004-4v-14a4 4 0 00-4-4z",
    fill: "#dee0ff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 204.54,
    y: 175.64,
    width: 24,
    height: 24,
    rx: 5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.54 200.65h-14a6 6 0 01-6-6v-14a6 6 0 016-6h14a6 6 0 016 6v14a6 6 0 01-6 6zm-14-24a4 4 0 00-4 4v14a4 4 0 004 4h14a4 4 0 004-4v-14a4 4 0 00-4-4z",
    fill: "#4355b9"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 204.54,
    y: 248.51,
    width: 24,
    height: 24,
    rx: 5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.54 273.51h-14a6 6 0 01-6-6v-14a6 6 0 016-6h14a6 6 0 016 6v14a6 6 0 01-6 6zm-14-24a4 4 0 00-4 4v14a4 4 0 004 4h14a4 4 0 004-4v-14a4 4 0 00-4-4z",
    fill: "#dee0ff"
  }))));
}
export default SvgWorkguideFeaturesAdaptable300X300;